import { Action } from '@ngrx/store';
import { Credentials, User, AuthResult } from '../../models';

export enum AuthActionTypes {
  Login = '[Auth] Login',
  Logout = '[Auth] Logout',
  LoginSuccess = '[Auth] Login Success',
  LoginFailure = '[Auth] Login Failure',
  LoginRedirect = '[Auth] Login Redirect',
  LoadUser = '[Auth] Load User',
  LoadUserSuccess = '[Auth] Load User Success',
}

export class Login implements Action {
  readonly type = AuthActionTypes.Login;

  constructor(public payload: Credentials) { }
}

export class LoginSuccess implements Action {
  readonly type = AuthActionTypes.LoginSuccess;

  constructor(public payload: AuthResult) { }
}

export class LoginFailure implements Action {
  readonly type = AuthActionTypes.LoginFailure;

  constructor(public payload: any) { }
}

export class LoginRedirect implements Action {
  readonly type = AuthActionTypes.LoginRedirect;
}

export class Logout implements Action {
  readonly type = AuthActionTypes.Logout;
}

export class LoadUser implements Action {
  readonly type = AuthActionTypes.LoadUser;
}

export class LoadUserSuccess implements Action {
  readonly type = AuthActionTypes.LoadUserSuccess;
  constructor(public payload: User) { }
}



export type AuthActions =
  | Login
  | LoginSuccess
  | LoginFailure
  | LoginRedirect
  | Logout
  | LoadUser
  | LoadUserSuccess;



// WEBPACK FOOTER //
// ./src/app/core/store/actions/auth.actions.ts